import { render } from "./ArticleComponent.vue?vue&type=template&id=11c0bf3b&scoped=true"
import script from "./ArticleComponent.vue?vue&type=script&lang=js"
export * from "./ArticleComponent.vue?vue&type=script&lang=js"

import "./ArticleComponent.vue?vue&type=style&index=0&id=11c0bf3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c0bf3b"]])

export default __exports__